import {
    useMediaQuery,
    Box,
    Button,
} from '@mui/material';

const ShortenBtn = ({ shorten }) => {
    const matchesDown700 = useMediaQuery('(max-width:700px)');
    return (
        <Box sx={{
            display: 'flex', 
            justifyContent: matchesDown700 ? 'center' : 'flex-end',
            mt: '2vw',
            mr: { 
                md: 3 
            }
        }}>
            <Button 
                variant="contained"
                onClick={shorten}
                sx={{
                    p: 2, 
                    borderRadius: '30px',
                    width: matchesDown700 ? '100%' : '180px',
                    textTransform: "none", 
                    fontWeight: 'bold',
                    fontSize: "16px",
                    boxShadow: 5, 
                }}
            >
                Shorten
            </Button>
        </Box>
    );
}

export default ShortenBtn;